import { render } from "./PhoneTypeComponent.vue?vue&type=template&id=42593cd6&scoped=true"
import script from "./PhoneTypeComponent.vue?vue&type=script&lang=js"
export * from "./PhoneTypeComponent.vue?vue&type=script&lang=js"

import "./PhoneTypeComponent.vue?vue&type=style&index=0&id=42593cd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42593cd6"]])

export default __exports__